import { HttpErrorResponse } from '@angular/common/http';

export const PAYMENTS_UNAVAILABLE_MESSAGE = 'Payments is temporarily unavailable. Nothing was changed. Try again in a few minutes.';
export const PAYMENT_NOT_READY_MESSAGE = 'Fees have not been invoiced yet.';

/**
 * The API's 503: ForthrightPayments could not be reached, so nothing was synced, locked or submitted.
 * Distinct from a revision conflict because the fix is simply to try again, not to reload.
 */
export class PaymentsUnavailableError extends Error {
  constructor(message: string = PAYMENTS_UNAVAILABLE_MESSAGE) {
    super(message);
    this.name = 'PaymentsUnavailableError';
  }
}

/** Checkout's 409: the fee can't be paid yet (not invoiced, or the party's organization isn't linked). */
export class PaymentNotReadyError extends Error {
  constructor(message: string = PAYMENT_NOT_READY_MESSAGE) {
    super(message);
    this.name = 'PaymentNotReadyError';
  }
}

export function paymentsUnavailableFromHttp(error: unknown): PaymentsUnavailableError | null {
  if (!(error instanceof HttpErrorResponse) || error.status !== 503) return null;
  return new PaymentsUnavailableError(problemDetail(error) ?? PAYMENTS_UNAVAILABLE_MESSAGE);
}

export function paymentNotReadyFromHttp(error: unknown): PaymentNotReadyError | null {
  if (!(error instanceof HttpErrorResponse) || error.status !== 409) return null;
  return new PaymentNotReadyError(problemDetail(error) ?? PAYMENT_NOT_READY_MESSAGE);
}

function problemDetail(error: HttpErrorResponse): string | null {
  const detail = error.error && typeof error.error === 'object' && 'detail' in error.error ? error.error.detail : null;
  return typeof detail === 'string' && detail.trim() ? detail : null;
}
